import { useState } from 'react';
import { ArrowLeft, ChevronLeft, ChevronRight } from '../../icons/wp-icons';
import { endImpersonate } from '../../api/superAdminApi';
import { toast } from 'react-hot-toast';
import { useEmbed } from '../../hooks/useEmbed';

const ImpersonateBanner = () => {
  const [loading, setLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const { isEmbed } = useEmbed();

  // Prüfen ob wir im Impersonate-Modus sind
  const isImpersonating = localStorage.getItem('isImpersonating') === 'true';
  const orgName = localStorage.getItem('impersonatedOrgName');

  // Im Embed-Mode (Cockpit-Preview Demo-Overlay) nicht anzeigen —
  // der Banner würde sonst über dem Demo-Content kleben.
  if (isEmbed) {
    return null;
  }

  if (!isImpersonating) {
    return null;
  }

  const handleEndImpersonate = async () => {
    setLoading(true);
    try {
      const result = await endImpersonate();

      // Impersonate-Flags löschen
      localStorage.removeItem('isImpersonating');
      localStorage.removeItem('impersonatedOrgName');

      // Normalen Token löschen
      localStorage.removeItem('token');

      // Super-Admin Token wiederherstellen
      localStorage.setItem('superAdminToken', result.token);

      // Zum Super-Admin Panel navigieren
      window.location.href = '/super-admin/dashboard';
    } catch (error) {
      console.error('End impersonate error:', error);
      toast.error('Fehler beim Beenden der Impersonation');

      // Bei Fehler trotzdem zurück zum Login
      localStorage.removeItem('isImpersonating');
      localStorage.removeItem('impersonatedOrgName');
      localStorage.removeItem('token');
      window.location.href = '/super-admin/login';
    }
    setLoading(false);
  };

  // Collapsed: Nur kleiner roter Streifen mit Icon
  if (collapsed) {
    return (
      <button
        onClick={() => setCollapsed(false)}
        className="fixed left-0 top-1/2 -translate-y-1/2 z-[9999] bg-red-600 hover:bg-red-700 text-white p-2 rounded-r-lg shadow-lg transition-all"
        title="Super-Admin Panel öffnen"
      >
        <div className="flex flex-col items-center gap-1">
          <img src="/favicon.png" alt="Logo" className="w-6 h-6 object-contain" />
          <ChevronRight className="w-4 h-4" />
        </div>
      </button>
    );
  }

  // Expanded: Vertikaler Banner an der linken Seite
  return (
    <div className="fixed left-0 top-1/2 -translate-y-1/2 z-[9999] flex">
      <div className="bg-red-600 text-white rounded-r-xl shadow-xl overflow-hidden">
        {/* Header mit Collapse-Button */}
        <div className="flex items-center justify-between px-3 py-2 bg-red-700">
          <div className="flex items-center gap-2">
            <img src="/favicon.png" alt="Logo" className="w-5 h-5 object-contain" />
            <span className="text-xs font-semibold uppercase tracking-wide">Super-Admin</span>
          </div>
          <button
            onClick={() => setCollapsed(true)}
            className="p-1 hover:bg-white/20 rounded transition-colors"
            title="Minimieren"
          >
            <ChevronLeft className="w-4 h-4" />
          </button>
        </div>

        {/* Content */}
        <div className="px-3 py-3 space-y-3">
          <div>
            <p className="text-xs text-red-200">Eingeloggt als</p>
            <p className="font-semibold text-sm truncate max-w-[140px]" title={orgName}>
              {orgName}
            </p>
          </div>

          <button
            onClick={handleEndImpersonate}
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-white/20 hover:bg-white/30 rounded-lg transition-colors text-xs font-medium disabled:opacity-50"
          >
            {loading ? (
              <>
                <span className="animate-spin rounded-full h-3 w-3 border-2 border-white border-t-transparent"></span>
                <span>Beende...</span>
              </>
            ) : (
              <>
                <ArrowLeft className="w-3 h-3" />
                <span>Zurück</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImpersonateBanner;
